import { render } from "./AppointmentDetail.vue?vue&type=template&id=2dffb0dd&scoped=true&ts=true"
import script from "./AppointmentDetail.ts?vue&type=script&lang=ts"
export * from "./AppointmentDetail.ts?vue&type=script&lang=ts"

import "./AppointmentDetail.scss?vue&type=style&index=0&id=2dffb0dd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dffb0dd"]])

export default __exports__